<template>
  <div class="banner" :style="background" :class="type">
    <div class="banner-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Banner',

  props: {
    img: String,
    type: String
  },

  computed: {
    background() {
      return this.img ? `background-image: url('${this.img}')` : false
    }
  }
}
</script>

<style lang="sass" scoped>
@import '../stylesheets/base/variables'
@import '../stylesheets/base/theme'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.banner
  background-size: cover
  background-position: 50% 50%
  min-height: $banner-height-small
  color: #fff
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  position: relative
  overflow: hidden
  box-shadow: inset 0 -5px 10px rgba(0, 0, 0, 0.1)

  @include themify($themes)
    background: themed('color-banner')

  @include media($media-gt-small)
    min-height: $banner-height-medium

  &.primary
    @include themify($themes)
      background: themed('color-primary')

  &.secondary
    @include themify($themes)
      background: themed('color-secondary')

  &.tertiary
    @include themify($themes)
      background: themed('color-tertiary')

  .banner-content
    position: relative
    text-align: center
    width: 100%
    padding: $gap-small

    @include media($media-gt-medium)
      padding: $gap-medium

    p, a
      color: #fff

  h1, h2
    text-transform: uppercase
    margin: 5px 0

  h1
    font-size: 34px
    color: #fff

  h2
    color: rgba(255, 255, 255, 0.5)

  p
    font-weight: bold
</style>
